export function formatTo12Hour(timeStr) {
  const [hours, minutes] = timeStr.split(':').map(Number);
  const date = new Date();
  date.setHours(hours, minutes);

  return date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
}

export function validateStoreHours(selectedDate, selectedTime, storeHours) {
  if (!selectedDate || !selectedTime || !storeHours) {
    return null;
  }

  const dayName = selectedDate
    .toLocaleDateString('en-US', { weekday: 'long' })
    .toLowerCase();

  const hours = storeHours[dayName];
  if (!hours || !hours.enabled || !hours.open || !hours.close) {
    return 'Store is closed on this day!';
  }

  // convert to minutes for easier comparison
  const [openH, openM] = hours.open.split(':').map(Number);
  const [closeH, closeM] = hours.close.split(':').map(Number);

  const openMinutes = openH * 60 + openM;
  const closeMinutes = closeH * 60 + closeM;

  const selectedMinutes =
    selectedTime.getHours() * 60 + selectedTime.getMinutes();

  if (selectedMinutes < openMinutes || selectedMinutes > closeMinutes) {
    return `This restaurant accepts orders between ( ${formatTo12Hour(
      hours.open,
    )} - ${formatTo12Hour(hours.close)} ) on selected day!`;
  }

  return null;
}